// Chat conversation data + inference metadata
// Risk levels: 0 = none, 1 = low, 2 = med, 3 = high
export const CHAT_DATA = {
  contact: { name: 'Alex', initials: 'A', subtitle: 'Random match' },

  // Canonical §6.2 RiskAxis[] fixture. Risk scores are 0.0–1.0
  // (higher = more exposed / riskier). Keeping the fixture in contract
  // shape means mock and HTTP clients feed identical values to the tool.
  meter: [
    { axis: 'Location', meValue: 1, themValue: 1 },
    { axis: 'Age', meValue: 1, themValue: 1 },
    { axis: 'Sex', meValue: 1, themValue: 1 },
    { axis: 'Occupation', meValue: 1, themValue: 1 },
    { axis: 'PlaceOfBirth', meValue: 1, themValue: 1 },
    { axis: 'MaritalStatus', meValue: 1, themValue: 1 },
    { axis: 'Income', meValue: 1, themValue: 1 },
    { axis: 'EducationLevel', meValue: 1, themValue: 1 },
  ],

  messages: [
    { id: 1, from: 'them', text: "hey, how's it going?", risk: 0 },
    {
      id: 2,
      from: 'them',
      text: 'I usually keep my weekends pretty low-key unless friends drag me out.',
      risk: 0,
    },
    { id: 3, from: 'them', text: 'What are your weekends usually like?', risk: 0 },
  ],
};

// F1 Mirror — session-wide breakdown
export const MIRROR_DATA = {
  // The new conversation starts with no participant-authored messages, so
  // there are no own-authorship findings to seed. Keep the fixture contract
  // valid until the first live or mock analysis populates it.
  sessionLength: 'No messages analyzed yet',
  categories: [],
};
